import { useTheme } from '@mui/material/styles';

export const useReactSelectTheme = () => {
  const muiTheme = useTheme();

  return (theme) => {
    const mergedTheme = {
      ...theme,
      borderRadius: muiTheme.shape.borderRadius,
      colors: {
        ...theme.colors,
        primary: muiTheme.palette.primary.main,
        primary75: muiTheme.palette.primary.light,
        primary50: muiTheme.palette.primary.light,
        primary25: muiTheme.palette.primary.light,
      }
      // spacing: {
      //   baseUnit: 4,
      //   controlHeight: 38,
      //   menuGutter: 8,
      //   ...(theme.spacing || {}),
      //   ...(muiTheme.spacing || {}),
      // },
    };

    // console.log('Merged theme in useReactSelectTheme:', mergedTheme);
    return mergedTheme;
  };
};